import { Button, Card, Container, Grid, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { enGB } from "date-fns/locale";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import { getPromoCodeWiseMemberListApi } from "src/api/commonapi";
import Page from "src/components/Page";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ArrowLeft } from "@mui/icons-material";
import CustomLoader from "src/components/CustomLoader";

export default function PromocodeMemberList() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [promocodeMemberList, setPromocodeMemberList] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [filtereddata, setFilteredData] = useState({
    search: "",
    s_date: null,
    e_date: null
  });

  useEffect(() => {
    handleGetPromocodeMemberList(filtereddata);
  }, [page, rowPerPage]);

  const handleGetPromocodeMemberList = async (data) => {
    setIsLoading(true);
    const resp = await getPromoCodeWiseMemberListApi({
      page: page,
      per_page: rowPerPage,
      p_code_id: state.p_code_id,
      search: data.search,
      start_date: data.s_date,
      end_date: data.e_date
    });
    setIsLoading(false);
    if (resp.status == 1) {
      setPromocodeMemberList(resp?.data?.data);
      setTotalRows(resp?.data?.counter);
    }
  };

  const columns = [
    {
      name: "No",
      // selector: (row, index) => (promocodeMemberList?.length || 0) -index,
      selector: (row, index) => totalRows - ((page - 1) * rowPerPage + index),
      sortable: false,
      width: "70px"
    },

    {
      name: "Member Name",
      selector: (row) => <span title={row?.m_name}>{row?.m_name}</span>,
      sortable: false,
      width: "200px"
    },
    {
      name: "Member Email",
      selector: (row) => <span title={row?.m_email_id}>{row?.m_email_id}</span>,
      sortable: false,
      width: "300px"
    },
    {
      name: "Contact No",
      selector: (row) => row?.mobile_no,
      sortable: false,
      width: "150px"
    },
    {
      name: "Joining Date",
      selector: (row) => row?.joining_date,
      sortable: false,
      width: "200px"
    }
  ];

  return (
    <Page title="LVB Promotion Reject Reasons | Local Vocal Business Group">
      <Container>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography variant="h4">Members List</Typography>
        </Grid>

        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
          <Grid item>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around"
              }}
            >
              <Button
                // style={{ marginTop: "23px" }}
                variant="contained"
                onClick={() => {
                  setPage(0);
                  navigate("/lvb-promocode");
                }}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            </div>
          </Grid>
          <Grid item>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              alignItems={{ xs: "stretch", sm: "center" }}
              flexWrap="wrap"
            >
              {/* <Grid item md={3} lg={3} xs={6}> */}
              <Stack>
                {/* <label>Search Member</label> */}
                <TextField
                  placeholder="Search Member"
                  label="Search Member"
                  autoComplete="off"
                  type="text"
                  size="small"
                  sx={{ width: 200 }}
                  name="search"
                  value={filtereddata?.search ? filtereddata?.search : ""}
                  onChange={(e) => {
                    setFilteredData({
                      ...filtereddata,
                      search: e.target.value
                    });
                  }}
                />
              </Stack>
              {/* </Grid> */}
              {/* <Grid item xs={12} sm={12} md={2} lg={2}> */}
              <Stack>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={enGB}
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    type="date"
                    name="s_date"
                    label="Start Date "
                    sx={{ width: 200 }}
                    inputFormat="dd/MM/yyyy"
                    value={
                      filtereddata.s_date
                        ? new Date(filtereddata.s_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                        : null
                    }
                    onChange={(newDate) => {
                      if (newDate instanceof Date && !isNaN(newDate)) {
                        const day = String(newDate.getDate()).padStart(2, "0");
                        const month = String(newDate.getMonth() + 1).padStart(2, "0");
                        const year = newDate.getFullYear();
                        setFilteredData({
                          ...filtereddata,
                          s_date: `${day}-${month}-${year}`
                        });
                      }
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        onKeyDown: (e) => e.preventDefault()
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} onKeyDown={(e) => e.preventDefault()} size="small" />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
              {/* </Grid> */}
              {/* <Grid item xs={12} sm={12} md={2} lg={2}> */}
              <Stack>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={enGB}
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    sx={{ width: 200 }}
                    type="date"
                    name="e_date"
                    label="End Date "
                    inputFormat="dd/MM/yyyy"
                    value={
                      filtereddata.e_date
                        ? new Date(filtereddata.e_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                        : null
                    }
                    onChange={(newDate) => {
                      if (newDate instanceof Date && !isNaN(newDate)) {
                        const day = String(newDate.getDate()).padStart(2, "0");
                        const month = String(newDate.getMonth() + 1).padStart(2, "0");
                        const year = newDate.getFullYear();
                        setFilteredData({
                          ...filtereddata,
                          e_date: `${day}-${month}-${year}`
                        });
                      }
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        onKeyDown: (e) => e.preventDefault()
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
              {/* </Grid> */}
              {/* <Grid item xs={12} sm={12} md={2} lg={2}> */}
              <Stack direction="row" spacing={1}>
                <Button
                  onClick={() => {
                    handleGetPromocodeMemberList(filtereddata);
                    //   setLoadingMoreData(-1);
                    //   getFilterLeadData();
                  }}
                  variant="contained"
                >
                  search
                </Button>
                <Button
                  onClick={async () => {
                    await setFilteredData({
                      search: "",
                      s_date: null,
                      e_date: null
                    });
                    await handleGetPromocodeMemberList({
                      search: "",
                      s_date: null,
                      e_date: null
                    });
                  }}
                  variant="contained"
                >
                  clear
                </Button>
              </Stack>
              {/* </Grid> */}
            </Stack>
          </Grid>
        </Grid>
        <Card className="p-2" style={{ padding: "15px", marginTop: "15px" }}>
          <DataTable
            filter
            pagination
            highlightOnHover
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={(p) => setPage(p)}
            onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
            columns={columns}
            data={promocodeMemberList != null && promocodeMemberList}
            progressPending={isLoading}
            progressComponent={<CustomLoader />}

            // expandableRows
            // expandableRowsComponent={ExpandableRow}
          />
        </Card>
      </Container>
    </Page>
  );
}
